import { render } from "./SearchModal.vue?vue&type=template&id=5bc52125"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=5bc52125&lang=css"
script.render = render

export default script